module.exports = {"230702001":"旭日街道","230702004":"红升街道","230702006":"前进街道","230702007":"朝阳街道","230702008":"东升街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230702.json
// module id = 683
// module chunks = 0